import { readonly, ref } from "vue";

const refreshTrigger = ref(0)

export function useRefresh() {
  const triggerRefresh = () => {
    refreshTrigger.value++
  }

  return {
    refreshTrigger: readonly(refreshTrigger),
    triggerRefresh
  }
}